import React from 'react';
export function useIsDesktop(breakpoint = 1024) {
    const [isDesktop, setIsDesktop] = React.useState(() => {
        if (typeof window === 'undefined')
            return false;
        try {
            return window.innerWidth >= breakpoint;
        }
        catch {
            return false;
        }
    });
    React.useEffect(() => {
        const onResize = () => {
            try {
                setIsDesktop(window.innerWidth >= breakpoint);
            }
            catch { }
        };
        try {
            window.addEventListener('resize', onResize, { passive: true });
        }
        catch { }
        // Initial sync in case SSR/hydration mismatch
        onResize();
        return () => { try {
            window.removeEventListener('resize', onResize);
        }
        catch { } ; };
    }, [breakpoint]);
    return isDesktop;
}
